export default {
	Initial: 'Initial',
	Completed: 'Completed',
	// Removing: 'Removing',
	// Destroy: 'Destroy',


	PendingRemoving: 'PendingRemoving',
	PendingCreating: 'PendingCreating',
	Pending: 'Pending',
	PendingFetching: 'PendingFetching',

}


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/data/ModelStatus.js